import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NurseryService } from '../services/nursery.service';

@Component({
  selector: 'app-nursery-products',
  templateUrl: './nursery-products.component.html',
  styleUrls: ['./nursery-products.component.scss']
})
export class NurseryProductsComponent implements OnInit {
  nurseryId: number;
  nursery: any;
  products: any[] = [];
  allProducts: any[] = [];
  categories: string[] = [];
  packagingTypes: string[] = [];

  keyword: string = '';
  category: string = '';
  packagingType: string = '';

  constructor(
    private route: ActivatedRoute,
    private nurseryService: NurseryService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.nurseryId = +params.get('id');

      this.loadNurseryData(this.nurseryId);
    });
  }

  private loadNurseryData(id: number) {
    this.nurseryService.getNurseryDataId(id).subscribe({
      next: nursery => {
        this.nursery = nursery;
      },
      error: err => {
        console.error('Failed to fetch nursery:', err);
      }
    });

    this.nurseryService.getNurseryProductDataId(id).subscribe({
      next: productsData => {
        this.allProducts = productsData;
        this.products = productsData;
        this.categories = productsData.map(data => data.product.category).filter((category, index, self) => self.indexOf(category) === index);
        this.packagingTypes = productsData
          .map(data => data.packaging_type)
          .filter((packagingType, index, self) =>
            self.findIndex(pt =>
              pt && packagingType && pt.name === packagingType.name
            ) === index
          );
      },
      error: err => {
        console.error('Failed to fetch nursery products:', err);
      }
    });
  }

  searchProducts() {
    this.products = this.allProducts.filter(data => {

      const nameCommon = data.product.name_common || '';
      const nameScientific = data.product.name_scientific || '';
      const genus = data.product.genus || '';
      const species = data.product.species || '';
      const cultivar = data.product.cultivar || '';
      const description = data.product.description || '';

      const matchesKeyword = !this.keyword ||
        nameCommon.toLowerCase().includes(this.keyword.toLowerCase()) ||
        nameScientific.toLowerCase().includes(this.keyword.toLowerCase()) ||
        genus.toLowerCase().includes(this.keyword.toLowerCase()) ||
        species.toLowerCase().includes(this.keyword.toLowerCase()) ||
        cultivar.toLowerCase().includes(this.keyword.toLowerCase()) ||
        description.toLowerCase().includes(this.keyword.toLowerCase());

      const matchesCategory = !this.category ||
        data.product.category.toLowerCase() === this.category.toLowerCase();

      const matchesPackagingType = !this.packagingType ||
        data.packaging_type.name === this.packagingType;

      return matchesKeyword && matchesCategory && matchesPackagingType;
    });
  }
}
